import { render } from "./VentasDetalle.vue?vue&type=template&id=1546152a&scoped=true"
import script from "./VentasDetalle.vue?vue&type=script&lang=js"
export * from "./VentasDetalle.vue?vue&type=script&lang=js"

import "./VentasDetalle.vue?vue&type=style&index=0&id=1546152a&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1546152a"]])

export default __exports__